export default __webpack_public_path__ + "static/media/dotted-shape.555cead3.svg";